import { useCallback } from 'react';
import { type NavigateOptions, type To, useNavigate } from 'react-router';
import { useOrganizationStore } from '@/stores/organization-store';

export const useONavigate = () => {
  const { currentOrganization } = useOrganizationStore();
  const navigate = useNavigate();

  return useCallback(
    ({ to, options }: { to: To; options?: NavigateOptions }) => {
      navigate(`/o/${currentOrganization.id}${to}`, options);
    },
    [currentOrganization.id],
  );
};
